import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

export const getClientPayClients = async (ReportType) => {
    try {
        const res = await axios.get(`${base}/Reports/GetClientPayclients`, { params: { ReportType } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch clients'); }
};

export const getClientPaySubClient = async (ReportType, Clientcode) => {
    try {
        const res = await axios.get(`${base}/Reports/GetClientPaySubClient`, { params: { ReportType, Clientcode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch sub-clients'); }
};

export const getClientPayCC = async (ReportType, Clientcode, SubClientcode, CCStatusval) => {
    try {
        const res = await axios.get(`${base}/Reports/GetClientPayCC`, { params: { ReportType, Clientcode, SubClientcode, CCStatusval } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch cost centres'); }
};

// POST — body field is `Reporttype` (lowercase t), matching ClientPaymentsReport domain entity
export const getClientPayPOInv = async ({ Reporttype, ClientCode, SubClientCode, SelectedCC }) => {
    try {
        const res = await axios.post(`${base}/Reports/GetClientPayPOInv`, { Reporttype, ClientCode, SubClientCode, SelectedCC });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch PO/Invoice numbers'); }
};

export const getClientPayAdvanceData = async (payload) => {
    try {
        const res = await axios.post(`${base}/Reports/GetClientPayAdvanceData`, payload);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch advance payments'); }
};

export const getClientPayRetentionData = async (payload) => {
    try {
        const res = await axios.post(`${base}/Reports/GetClientPayRetentionData`, payload);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch retention payments'); }
};

export const getClientPayHoldData = async (payload) => {
    try {
        const res = await axios.post(`${base}/Reports/GetClientPayHoldData`, payload);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch hold payments'); }
};
